import { render, staticRenderFns } from "./BCXMessengerChatPreview.vue?vue&type=template&id=2cc51f5a&scoped=true"
import script from "./BCXMessengerChatPreview.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerChatPreview.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerChatPreview.vue?vue&type=style&index=0&id=2cc51f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc51f5a",
  null
  
)

export default component.exports